module.exports = __webpack_public_path__ + "static/img/male.6da7171.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/male.png
// module id = U6na
// module chunks = 1